<template>
  <div class="login-container">
    <h2>Login</h2>
    <form @submit.prevent="handleLogin">
      <div>
        <label for="username">Username:</label>
        <input type="text" id="username" v-model="username" required />
      </div>
      <div>
        <label for="password">Password:</label>
        <input type="password" id="password" v-model="password" required />
      </div>
      <button type="submit">Login</button>
    </form>
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      error: "",
    };
  },
  methods: {
    handleLogin() {
      // 这里可以添加登录逻辑，例如API调用等
      if (this.username === "admin" && this.password === "123456") {
        // 假设登录成功后，服务器返回了一个token
        const token = "your-token-from-server";
        localStorage.setItem("userToken", token);
        // 重定向到主页或其他需要认证的路由
        // 登录成功处理，例如跳转到首页或者设置用户状态等
        this.$router.push("/"); // 确保你已经设置了Vue Router
      } else {
        this.error = "Invalid username or password"; // 显示错误信息
      }
    },
    // ...其他方法
    logout() {
      localStorage.removeItem("userToken");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.login-container {
  max-width: 300px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
label {
  display: block;
  margin-bottom: 5px;
}
input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
}
button {
  width: 100%;
  padding: 10px;
}
</style>
